// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ek-z","tupacHeader":"Fk-z","tupacHeader2":"Gk-z","tupacMenu":"Hk-z","tupacMenu2":"Ik-z","tupacMain":"Jk-z","tupacMain2":"Kk-z"};